export interface TransitionReportContract {
  id: number;
  first_name: string;
  last_name: string;
  birth_date: string;
  street_and_house_number: string;
  city: string;
  district: string;
  postal_code: string;
  country: string;
  interests: string;
  comp_learning_describes_success: boolean;
  comp_learning_seeks_help: boolean;
  comp_learning_persists: boolean;
  comp_communication_expresses_clearly: boolean;
  comp_communication_listens: boolean;
  comp_communication_uses_language: boolean;
  comp_social_knows_strengths: boolean;
  comp_social_cooperates: boolean;
  comp_social_resolves_conflicts: boolean;
  comp_citizenship_reflects: boolean;
  comp_citizenship_creates_rules: boolean;
  comp_citizenship_empathy: boolean;
  comp_work_plans: boolean;
  comp_work_completes: boolean;
  comp_work_follows_rules: boolean;
  comp_problem_solving_proposes: boolean;
  comp_problem_solving_describes: boolean;
  comp_problem_solving_seeks_alternatives: boolean;
  comp_cultural_participates: boolean;
  comp_cultural_understands_values: boolean;
  comp_cultural_respects_diversity: boolean;
  comp_digital_uses_tools: boolean;
  comp_digital_understands_purpose: boolean;
  comp_digital_follows_rules: boolean;
  additional_strengths: string;
  method_text: string;
  method_speaking_listening: boolean;
  method_demonstration: boolean;
  method_manipulation: boolean;
  method_role_play: boolean;
  method_learning_by_rules: boolean;
  method_creative_learning: boolean;
  method_reflection: boolean;
  method_group_learning: boolean;
  method_digital_support: boolean;
  org_form_collective: boolean;
  org_form_group: boolean;
  org_form_activity_centers: boolean;
  org_form_individual: boolean;
  org_form_free_play: boolean;
  org_form_outdoor: boolean;
  org_form_circle_time: boolean;
  org_form_routine: boolean;
  org_form_project: boolean;
  family_cooperation: string;
  socioemotional_support_needed: boolean;
  socioemotional_notes: string;
  language_support_needed: boolean;
  language_notes: string;
  gross_motor_support_needed: boolean;
  gross_motor_level: string;
  gross_motor_diagnostic_date: string;
  gross_motor_notes: string;
  fine_motor_support_needed: boolean;
  fine_motor_level: string;
  fine_motor_diagnostic_date: string;
  fine_motor_notes: string;
  visual_perception_support_needed: boolean;
  visual_perception_level: string;
  visual_perception_diagnostic_date: string;
  visual_perception_notes: string;
  auditory_perception_support_needed: boolean;
  auditory_perception_level: string;
  auditory_perception_diagnostic_date: string;
  auditory_perception_notes: string;
  support_measures_recommended: boolean;
  created: string;
  modified: string;
}

export interface TransitionReportUpdateContract {
  first_name: string;
  last_name: string;
  birth_date: string;
  child_gender: string;
  street_and_house_number: string;
  city: string;
  district: string;
  postal_code: string;
  country: string;
  interests: string;
  comp_learning_describes_success: boolean;
  comp_learning_seeks_help: boolean;
  comp_learning_persists: boolean;
  comp_communication_expresses_clearly: boolean;
  comp_communication_listens: boolean;
  comp_communication_uses_language: boolean;
  comp_social_knows_strengths: boolean;
  comp_social_cooperates: boolean;
  comp_social_resolves_conflicts: boolean;
  comp_citizenship_reflects: boolean;
  comp_citizenship_creates_rules: boolean;
  comp_citizenship_empathy: boolean;
  comp_work_plans: boolean;
  comp_work_completes: boolean;
  comp_work_follows_rules: boolean;
  comp_problem_solving_proposes: boolean;
  comp_problem_solving_describes: boolean;
  comp_problem_solving_seeks_alternatives: boolean;
  comp_cultural_participates: boolean;
  comp_cultural_understands_values: boolean;
  comp_cultural_respects_diversity: boolean;
  comp_digital_uses_tools: boolean;
  comp_digital_understands_purpose: boolean;
  comp_digital_follows_rules: boolean;
  additional_strengths: string;
  method_text: string;
  method_speaking_listening: boolean;
  method_demonstration: boolean;
  method_manipulation: boolean;
  method_role_play: boolean;
  method_learning_by_rules: boolean;
  method_creative_learning: boolean;
  method_reflection: boolean;
  method_group_learning: boolean;
  method_digital_support: boolean;
  org_form_collective: boolean;
  org_form_group: boolean;
  org_form_activity_centers: boolean;
  org_form_individual: boolean;
  org_form_free_play: boolean;
  org_form_outdoor: boolean;
  org_form_circle_time: boolean;
  org_form_routine: boolean;
  org_form_project: boolean;
  family_cooperation: string;
  socioemotional_support_needed: boolean;
  socioemotional_notes: string;
  language_support_needed: boolean;
  language_notes: string;
  gross_motor_notes: string;
  fine_motor_notes: string;
  visual_perception_notes: string;
  auditory_perception_notes: string;
  support_measures_recommended: boolean;
}
